<template>
  <Disclosure v-slot="{ open }" :defaultOpen="false">
    <DisclosureButton
      class="flex justify-between text-sm text-left focus:outline-none focus-visible:ring-opacity-75"
      v-if="message && message.length"
    >
      <div
        class="flex flex-row items-centerflex flex-row justify-center mb-1"
        v-if="message && message.length"
      >
        <rejected-icn
          v-if="!open && message[0].isNewest"
          width="16"
          height="16"
          class="mt-1.5"
          style="align-self: baseline "
        />
        <span
          class="ml-1 text-lg text-red"
          style="width: 575px; white-space: normal; word-wrap: break-word;"
          v-if="!open && message[0].isNewest"
          >{{ message[0].comment }}</span
        >
        <reject-history-icn
          v-if="open"
          width="30px"
          height="30px"
          :class="`w-7 h-5 mt-1 ${color}-icon`"
        >
        </reject-history-icn>
        <span v-if="open" :class="`text-lg text-${color}`">履歴</span>
      </div>
      <reject-history-icn
        v-if="!open"
        width="30px"
        height="30px"
        :class="`w-7 h-5 mr-5 mt-1 ${color}-icon`"
        style="position: absolute; right: -15px;"
      >
        <!-- :style="
          message[0].isNewest
            ? 'position: absolute; right: -15px;'
            : 'position: absolute; right: -15px;'
        " -->
      </reject-history-icn>
      <chevron-icn
        v-if="open"
        width="20px"
        height="20px"
        class="w-7 h-5 mt-1"
        :class="open ? `transform rotate-180 ${color}-icon` : `${color}-icon`"
        style="position: absolute; right: 5px;"
      ></chevron-icn>
    </DisclosureButton>

    <DisclosurePanel>
      <tr
        style="height:20px;"
        v-for="item in message.slice().reverse()"
        :key="item.id"
      >
        <td>
          <div
            class="flex flex-row items-center mb-1"
            v-if="message && message.length"
          >
            <rejected-icn
              v-if="item.isNewest"
              style="position: relative; top:1px; align-self: baseline;"
              width="16"
              height="16"
            />
            <approved-not-circle-icn
              v-if="!item.isNewest"
              :class="`${color}-icon`"
              style="position: relative; top:2px; align-self: baseline;"
              width="18"
              height="18"
            />
            <span
              class="ml-1 text-lg"
              :class="item.isNewest ? 'text-red' : `text-${color}`"
              style="width: 575px; white-space: normal; word-wrap: break-word;"
              >{{ item.comment }}</span
            >
            <span
              class="ml-1 text-lg "
              :class="item.isNewest ? 'text-red' : `text-${color}`"
              style="align-self: baseline; white-space: nowrap;"
            >
              | {{ dayjs(item.createdAt).format('MM/DD') }}</span
            >
          </div>
        </td>
      </tr>
    </DisclosurePanel>
  </Disclosure>
</template>

<script>
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import RejectHistoryIcn from '@/assets/icons/reject-history.svg?inline'
import ApprovedNotCircleIcn from '@/assets/icons/approved-not-circle.svg?inline'
import ChevronIcn from '@/assets/icons/chevron.svg?inline'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'

export default {
  name: 'AppPreviewSentBackItem',

  components: {
    RejectedIcn,
    RejectHistoryIcn,
    ApprovedNotCircleIcn,
    ChevronIcn,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
  },

  props: {
    message: Array,
    color: String,
  },
}
</script>
<style lang="scss"></style>
